import Facebook from '../../assets/images/icone-facebook-white.png';
import Instagram from '../../assets/images/icone-instagram-white.png';
import Linkedin from '../../assets/images/icone-linkedin-white.png';
import Youtube from '../../assets/images/icone-youtube-white.png';

const Footer = () => {
    return (
        <footer>
            <div style={{height: '60px', backgroundColor: '#000'}}></div>
            <div className="footer">
                <div className="container">
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <p className='text-white'>Estamos ansiosos para recebê-lo nessa jornada inspiradora!</p>
                        </div>
                    </div>

                    <ul class="nav justify-content-center">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                href="https://www.facebook.com/premiumclubeoficial/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={Facebook}
                                    width={50}
                                    alt="Facebook Lideres do Sucesso"
                                />
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                href="https://www.instagram.com/premiumclubeoficial/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={Instagram}
                                    width={50}
                                    alt="Instagram Lideres do Sucesso"
                                />
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                href="https://www.linkedin.com/company/premium-clube/mycompany/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={Linkedin}
                                    width={50}
                                    alt="Linkedin Lideres do Sucesso"
                                />
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                href="https://www.youtube.com/channel/UCCRvg9MYF6b6s42SyJva1Dw"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={Youtube}
                                    width={50}
                                    alt="Youtube Lideres do Sucesso"
                                />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;